import * as localisationFn from "@/shared/composables/use-localisation-functions";

export const useLocalisation = () => ({
  ...localisationFn,
});
